import React from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import "../styles/AboutUs.css";
import healthcareImage from "../assets/aboutus.jpg";

function AboutUs() {
  return (
    <>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>About Relison Pharma – Global Pharmaceutical Company</title>
        <meta
          name="description"
          content="Relison Pharma is an emerging global pharmaceutical company specializing in manufacturing, marketing, and distribution with a vision for healthcare innovation."
        />
        <meta
          name="keywords"
          content="About Relison, pharma company, pharmaceutical manufacturing, healthcare innovation, marketing medicines"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Relison Pharma" />
        <meta property="og:title" content="About Relison Pharma – Global Pharmaceutical Company" />
        <meta property="og:description" content="Relison Pharma is a rising pharma brand focusing on global markets, innovative healthcare, and trustworthy medicines." />
        <meta property="og:image" content="https://relisonpharma.com/images/aboutus.jpg" />
        <meta property="og:url" content="https://relisonpharma.com/about/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Relison Pharma" />
        <meta name="twitter:description" content="Explore Relison Pharma’s mission, vision, and capabilities as a global healthcare innovator." />
        <meta name="twitter:image" content="https://relisonpharma.com/images/aboutus.jpg" />
      </Helmet>


      {/* ================= ABOUT HERO ================= */}
      <section className="about-hero">
        <div className="about-container">
          <div className="about-text">
            <h1>About Relison Pharma</h1>

            <p>
              <strong>Relison Pharma</strong> is a pharmaceutical marketing
              company in India committed to delivering high-quality, safe, and
              affordable healthcare solutions. Guided by our belief —
              <span className="highlight"> Serving Human Lives</span> — we focus
              on ethical practices and long-term healthcare value.
            </p>

            <p>
              We collaborate with{" "}
              <strong>WHO-GMP certified manufacturers</strong> to market
              scientifically validated pharmaceutical formulations across
              multiple therapeutic segments, ensuring safety, consistency, and
              compliance.
            </p>

            <p>
              With a growing pan-India presence, Relison Pharma combines medical
              expertise, professional marketing, and reliable distribution to
              build trusted healthcare brands.
            </p>
          </div>

          <div className="about-image">
            <img src={healthcareImage} alt="Relison Pharma Healthcare" />
          </div>
        </div>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="about-values">
        <div className="values-container">
          <div className="value-block">
            <h2>Our Vision</h2>
            <p>
              To become a trusted and leading pharmaceutical marketing company
              in India, recognized for ethical practices, high-quality
              healthcare products, and a strong commitment to improving patient
              lives.
            </p>
          </div>

          <div className="value-block">
            <h2>Our Mission</h2>
            <ul>
              <li>Market safe, effective, and quality pharmaceutical products</li>
              <li>Practice ethical and transparent pharma marketing</li>
              <li>Collaborate with WHO-GMP certified manufacturers</li>
              <li>Strengthen pan-India distribution and marketing excellence</li>
              <li>Continuously innovate and expand our product portfolio</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= WHY RELISON ================= */}
      <section className="why-relison ">
        <div className="why-relison-container">
          
          <h2>Why Relison Pharma?</h2>

          <p className="why-relison-intro">
            A commitment to quality, ethics, and responsible healthcare
            marketing defines everything we do.
          </p>

          <div className="why-point">
  <span className="why-icon">⚖️</span>
    <div className="why-point-content">

  <h3>Ethical Pharma Marketing</h3>
  <p>
    We follow transparent and responsible marketing practices that
    prioritize patient well-being and long-term trust.
  </p>
</div>
</div>
<div className="why-point">
  <span className="why-icon">🧪</span>
      <div className="why-point-content">

  <h3>Quality-Driven Products</h3>
  <p>
    All products are sourced from WHO-GMP certified manufacturers
    to ensure safety, consistency, and regulatory compliance.
  </p>
</div>
</div>
<div className="why-point">
  <span className="why-icon">🤝</span>
        <div className="why-point-content">

  <h3>Strong Healthcare Partnerships</h3>
  <p>
    We work closely with doctors, pharmacists, and distributors to
    build dependable healthcare brands.
  </p>
</div>
</div>

<div className="why-point">
  <span className="why-icon">📍</span>
    <div className="why-point-content">
       <h3>Pan-India Growth Vision</h3>
       <p>
        Our expanding distribution network supports sustained growth
        across key markets in India.
      </p>
    </div>
</div>

        </div>
      </section>
    </>
  );
}
export default AboutUs;
